import React from 'react'
import { DropdownMenuProps } from '../types'
import { PrivacyShield } from './PrivacyShield'
import { OrganizationList } from './OrganizationList'
import { Stack, Typography, List, Divider } from '@mui/material'

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
    organizations,
    isDarkMode,
    isPrivacyShieldOpen,
    onRemovePrivacyShield,
    onOrganizationSelect,
}) => (
    <Stack
        className="dropdown-menu"
        sx={{
            backgroundColor: 'figma.grayscale.contentWrapper',
        }}
        spacing={3}
    >
        <Typography className="dropdown-header" color="figma.primary">
            Change Organization
        </Typography>

        {isPrivacyShieldOpen ? (
            <PrivacyShield onClick={onRemovePrivacyShield} />
        ) : (
            <List className="organization-list" background-color="figma.primary">
                <OrganizationList
                    organizations={organizations}
                    isDarkMode={isDarkMode}
                    onOrganizationSelect={onOrganizationSelect}
                />
            </List>
        )}
    </Stack>
)
